import React, { useState, useEffect } from "react";
import { Form, Input, Button, Row, Col, Card, Table, Tag, notification } from "antd";
import {useLocation} from 'react-router-dom'
import styled from "styled-components";
import axios from 'axios'

const Detail = () => {
    const token = localStorage.getItem("token")
    const loc = useLocation()
    const [username, setUsername] = useState("")
    const [password, setPassword] = useState("")
    const [oriData, setoridata] = useState({})
    const [loading, setLoading] = useState(false)

    const getData = async (id) => {
        let fetch = await axios.get('https://api.rajarental.co.id/api/v1.0/admin/admin/' + id, {headers: {
          Authorization: token
        }})

        if(fetch) {
            let data = fetch.data.response
          setUsername(data.username)
          setoridata(data)
        }
      }

      useEffect(() => {
        if(loc.search && loc.search !== "") {
            getData(loc.search.split("?")[1].split("=")[1])
        }
      }, [])

      const submitForm = async () => {
          try {
              setLoading(true)
              
              if(loc.search && loc.search !== "") {
                  let id = loc.search.split("?")[1].split("=")[1]
                  let body = {}
                  let state = {
                      username
                  }
                  for(let key in oriData) {
                      if(oriData[key] != state[key]) {
                          body[key] = state[key]
                      }
                  }
                  if(username !== "") {
                      let update = await axios.put('https://api.rajarental.co.id/api/v1.0/admin/admin/' + id, 
                        body,{headers: {
                        Authorization: token
                    }})

                    if(update) {
                        setLoading(false)
                        notification["success"]({
                            message: "Success Edit",
                        });
                        window.location.href = "/dashboard/admin"
                    }
                  } else {
                    setLoading(false)
                    notification["warning"]({
                        message: "Username wajib diisi",
                        description:
                          "Please try again",
                      });
                  }
                  
              } else {
                  if(username !== "" && password !== "") {
                    let create = await axios.post('https://api.rajarental.co.id/api/v1.0/admin/admin/', {
                        username,
                        password
                    },{headers: {
                        Authorization: token
                    }})

                    if(create) {
                        setLoading(false)
                        notification["success"]({
                            message: "Success Add Admin",
                        });
                        window.location.href = "/dashboard/admin"
                    }
                  } else {
                    setLoading(false)
                    notification["warning"]({
                        message: "Username dan Password wajib diisi",
                        description:
                          "Please try again",
                      });
                  }
                
              }
          } catch (error) {

            console.log(error)
            setLoading(false)
            notification["warning"]({
                message: "Error",
                description:
                  "Please try again",
              });
          }
      }

    

    

    // console.log(username)

    return (
        <React.Fragment>
            <Card size="small" style={{padding: "20px 30px"}}>
                <Row justify="space-between">
                    <Col span={11}>
                        <p style={{marginBottom: 5}}>Username</p>
                        <Input value={username} placeholder="admin username" onChange={(e) => setUsername(e.target.value.split(" ").join("").toLowerCase())}/>
                    </Col>
                    
                    {
                        !loc.search && loc.search === ""  &&
                        <Col span={11}>
                            <p style={{marginBottom: 5}}>Password</p>
                            <Input.Password value={password} placeholder="admin password" onChange={(e) => setPassword(e.target.value)}/>
                        </Col>
                    }
                    
 
                    <Col span={24}>
                        <Button style={{float: 'right', marginTop: 25}} type="primary" loading={loading} onClick={submitForm}>Submit</Button>
                    </Col>
                    
                </Row>
            </Card>
        </React.Fragment>
    )
}

export default Detail